// extracted by mini-css-extract-plugin
module.exports = {"addStudyBanner":"AddStudyBanner_addStudyBanner__3fhy6","noStudies":"AddStudyBanner_noStudies__1JnDD","addBtn":"AddStudyBanner_addBtn__2rgcd"};